/**
 * STS Theme Main JavaScript
 * 
 * This file serves as the main entry point for the STS theme's JavaScript.
 * It handles theme-specific functionality and interactions.
 */

import "./menu";
import { initEntryContentWidth } from "./entry-content-width";

document.addEventListener("DOMContentLoaded", () => {
    initEntryContentWidth();
});
